import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FilesModalComponent } from '../comments/files-modal/files-modal.component';
import { ProjectService } from '../../api/services/project.services';
import { Worksheet } from '../../api/models/worksheet';
import { ProductAliasService } from '../../api/services/product-alias.service';
import { RogLinesTableComponent } from './rog-lines-table/rog-lines-table.component';

@Component({
  selector: 'app-rog-confirmation-dialog',
  templateUrl: './rog-confirmation-dialog.component.html',
  styleUrls: ['./rog-confirmation-dialog.component.scss']
})
export class RogConfirmationDialogComponent implements OnInit {

  @Input() worksheetId: string;
  worksheet: Worksheet;

  @ViewChild(RogLinesTableComponent)
  private linesTable: RogLinesTableComponent;

  fileIds = [];

  shipmentProblems = ['Short', 'Wrong', 'Damaged', 'Over'];
  problemSelected = '';
  showReportDialog = false;
  linesSelected = [];
  lines = [];

  constructor(
    public activeModal: NgbActiveModal,
    private modalService: NgbModal,
    private projectService: ProjectService,
    private productService: ProductAliasService
  ) { }

  openFilesModal() {
    const modalRef = this.modalService.open(FilesModalComponent, {
      backdrop : 'static',
      keyboard : false
    });
    modalRef.componentInstance.type = 'Add';

    modalRef.result.then(result => {
      this.fileIds = result;
    });
  }

  selectProblem(problem: string) {
    this.problemSelected = problem;
    this.showReportDialog = true;
  }

  confirmItems() {
    this.linesTable.setStatus(this.linesSelected, 'Received');
  }

  reportProblem() {
    this.linesTable.setStatus(this.linesSelected, this.problemSelected);
    this.problemSelected = '';
    this.showReportDialog = false;
  }

  onLinesUpdate(linesSelected: any[]) {
    this.linesSelected = linesSelected;
  }

  ngOnInit() {
    this.projectService.getWorksheet(this.worksheetId).subscribe(w => {
      this.worksheet = w;
      const lines: any[] = [{id: '1', sku: '31493', qtyShipped: 50},
       {id: '2', sku: '367000', qtyShipped: 20}, {id: '3', sku: '205662', qtyShipped: 100}];
      this.productService.productDetails(lines.map(line => line.sku)).subscribe(details => {
        lines.forEach(line => {
          const data = details.find(d => d.sku === line.sku);
          line.details = data;
          line.status = '-';
        });
        this.lines = lines;
      });
    });
  }

}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/rog-confirmation-dialog/rog-confirmation-dialog.component.ts